import { Link } from '@customink/pigment-react';
import type { ProductStyleId } from '@customink/project-service-react-components';

import { useSizingGuide } from '@/hooks/useSizingGuide';

export function SizingGuide({
  hasLineup,
  productId,
}: {
  hasLineup: boolean | undefined;
  productId: ProductStyleId | undefined;
}) {
  const { openSizingGuide } = useSizingGuide(productId);

  return hasLineup && productId ? (
    <Link
      fontSize="14px"
      fontWeight="600"
      lineHeight="1.25"
      onClick={openSizingGuide}
      rel="noreferrer noopener"
      target="_blank"
    >
      View Sizing Guide
    </Link>
  ) : null;
}
